<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import InputMultiTexts from '@/components(new)/UI/Forms/InputMultiTexts/InputMultiTexts.vue'

export default {
  components: {
    TitleWithRow,
    InputMultiTexts
  },
  props: {
    observer: {
      required: true
    },
    nomeAba: {
      type: String,
      required: true
    },
    emails: {
      type: Array,
      default: () => []
    },
    telefones: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    updateEmail (val) {
      this.$emit('update:emails', val.map(v => ({ dado: v })))
    },
    updateTelefones (val) {
      this.$emit('update:telefones', val.map(v => ({ numero: v })))
    }
  },
  created () {
    this.telefonesAux = this.telefones?.map(t => t.numero) || []
    this.emailsAux = this.emails?.map(t => t.dado) || []
  },
  data () {
    return {
      telefonesAux: [],
      emailsAux: []
    }
  },
  watch: {
    telefonesAux (newValue, oldValue) {
      this.updateTelefones(newValue)
    },
    emailsAux (newValue, oldValue) {
      this.updateEmail(newValue)
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Contatos:" />
    <el-row>
      <InputMultiTexts
        label="Email(s)" :nomeAba="nomeAba"
        :obrigatorio="true"
        :observer="observer"
        :widthColumn="6"
        :maxlengthButtonDisabled="10"
        v-model="emailsAux"
      />
      <InputMultiTexts
        label="Telefone(s)" :nomeAba="nomeAba"
        :obrigatorio="true"
        :observer="observer"
        :widthColumn="6"
        :maxlengthButtonDisabled="13"
        :marginLeft="true"
        v-model="telefonesAux"
        :vMask="['(##) #####-####', '(##) ####-####']"
      />
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/FormulariosProntos/Contatos/Contatos.vue